export type ExecutionRunsPageTab = 'execution-runs' | 'results-files' | 'uploads';

export const executionRunsPageTabs: ReadonlyArray<{
  label: string;
  value: ExecutionRunsPageTab;
}> = [
  { label: 'Execution Runs', value: 'execution-runs' },
  { label: 'Results Files', value: 'results-files' },
  { label: 'Uploads', value: 'uploads' },
];
